var $c23042f930ed2466$exports = {};
$c23042f930ed2466$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


export {$c23042f930ed2466$exports as default};
//# sourceMappingURL=bg-BG.module.js.map
